<template>
  <div class="singleDisbursementModal">
    <el-dialog :visible.sync="dialogVisible" class="diglog-card" :title="$t('data.bank_account_status')" :close-on-click-modal="false" width="509px" @close="closeModal">
      <div class="header-line" />
      <div v-for="(item, index) in approvedList" :key="index" class="section-title">
        Your bank account <span class="bank-no">{{ `${item.settlement_bank} (${item.settlement_bank_account_num}) ` }}</span> {{ `has been ${item.audit_status === 2 ? 'approved' : 'rejected'}.` }}
      </div>
      <div v-for="(item, index) in rejectedList" :key="index">
        <div class="section-title">
          Your bank account <span class="bank-no">{{ `${item.settlement_bank} (${item.settlement_bank_account_num}) ` }}</span> {{ `has been ${item.audit_status === 2 ? 'approved' : 'rejected'}.` }}
        </div>
        <div v-if="item.audit_status === 3" class="section-tip">
          <span>Rejection Reason:</span>
          <span>{{ item.audit_back_reason }}</span>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button> -->
        <el-button type="info" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn">{{ $t('components.proceed') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { updatePaymentInfo } from '@/api/online-transaction/online-transaction.js'
// import { fetchDisbursementAllCodeList } from '@/api/components/components.js'
// import { fetchAvailableChannelList } from '@/api/components/components'
export default {
  name: 'Review_Result_Modal',
  data() {
    return {
      singlePaymentForm: {},
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false,
      loading: false,
      auditResultList: [],
      rule: {
        payment_type: [
          { required: true, message: 'MFA Verification Code cannot be empty', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    approvedList() {
      return this.auditResultList.filter(i => i.audit_status === 2)
    },
    rejectedList() {
      return this.auditResultList.filter(i => i.audit_status === 3)
    }
  },
  created() {
    this.handleNotify()
    this.$bus.on('GET_NOTIFY', () => {
      this.handleNotify()
    })
  },
  methods: {
    handleNotify() {
      if (this.loading) return
      this.loading = true
      this.$store.dispatch('user/getNotifyInfo').then(res => {
        const list = res.data && res.data.bank_history_list || []
        if (list.length) {
          this.dialogVisible = true
          this.auditResultList = list
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 改变弹框状态
    // changeModalStatus(flag, info = []) {
    //   this.dialogVisible = flag
    //   this.auditResultList = info
    // },
    closeModal() {
      this.$store.dispatch('user/closeNotifyInfo')
    },
    onClickSubmitBtn() {
      this.$store.dispatch('user/closeNotifyInfo').then(res => {
        if (this.$store.getters.isAgentMerchant) {
          this.$router.push({
            name: 'Financial_Manage_Agent_Setting'
          })
        } else {
          this.$router.push({
            name: 'Financial_Manage_Setting'
          })
        }
        this.dialogVisible = false
      })
      // this.$refs.singlePaymentForm.validate((valid) => {
      //   if (valid) {
      //     this.submiting = true
      //     const params = [this.singlePaymentForm]
      //     updatePaymentInfo(params).then(res => {
      //       if (res.code === 10000) {
      //         this.dialogVisible = false
      //         this.$emit('getPaymentRefernceDetail')
      //       }
      //     }).finally(() => {
      //       this.submiting = false
      //     })
      //   }
      // })
    }
  }
}
</script>

  <style scoped lang="scss">
  .icon-question{
    position: relative;
    top: -1px;
    margin-left: 5px;
    font-size: 12px;
  }
  .select-item{
    width: 100%;
  }
  .tip{
    font-size: 14px;
    font-weight: 400;
    color: #303133;
  }
  .dialog-footer{
    margin-top: -16px;
    text-align: center;
  }
  .btn-submit{
    max-width: 500px;
    width: 100%;
    height: 40px;
    border-radius: 4px;
  }
  .section-title {
    font-size: 15px;
    font-weight: bold;
    color: #4B5567;
    word-break: keep-all;
    .bank-no {
      word-wrap: break-word;
      color: #3855F1;
    }
  }
  .section-tip {
    font-size: 14;
    color: #000000;
    font-weight: normal;
  }
  </style>
